import persianDate from "persian-date";

/**
 * contains helper classess for dates
 */
class DateUtils {
    /**
     *
     * @param {Date} date
     * @return {string}
     */
    static toServerDate(date) {
        let month = date.getMonth() + 1;
        let day = date.getDate();

        month = month.toString().length > 1 ? month : `0${month}`;
        day = day.toString().length > 1 ? day : `0${day}`;
        return `${date.getFullYear()}-${month}-${day}`;
    }

    static timestampToServerDate(timestamp) {
        const ts = timestamp.toString().length === 10? +timestamp * 1000: +timestamp;
        return this.toServerDate(new Date(ts));
    }

    /**
     * convert server date to persian date
     * @param {string} date
     * @return {string}
     */
    static toPersianDate(date) {
        const date_array = date.split("-");
        const pdate = new persianDate(
            new Date(+date_array[0], +date_array[1] - 1, +date_array[2])
        );

        return pdate.format("YYYY/MM/DD");
    }

    static timestampToPersianDate(timestamp) {
        const serverDate = this.timestampToServerDate(timestamp);
        return this.toPersianDate(serverDate);
    }
    /**
     * convert server date to persian date
     * @param {string} date
     * @return {any}
     */
    static toPersianDateClass(date) {
        const date_array = date.split("-");
        const pdate = new persianDate(
            new Date(+date_array[0], +date_array[1] - 1, +date_array[2])
        );

        return pdate;
    }

    /**
     * return this persian monthh start and end as garegorian server date
     * @return {{start: string, end: string}}
     */
    static thisPersianMonth() {
        const now = new persianDate();
        const this_month_start_g = now.startOf("month").toCalendar("gregorian");
        const this_month_end_g = now.endOf("month").toCalendar("gregorian");

        const day_start = String(this_month_start_g.date()).padStart(2, "0");
        const day_end = String(this_month_end_g.date()).padStart(2, "0");

        const moth_start = String(this_month_start_g.month()).padStart(2, "0");
        const moth_end = String(this_month_end_g.month()).padStart(2, "0");

        const start = `${this_month_start_g.year()}-${moth_start}-${day_start}`;
        const end = `${this_month_end_g.year()}-${moth_end}-${day_end}`;

        return { start, end };
    }

    /**
     * Returns the last 30 days of the Jalali calendar including today in the Gregorian calendar format
     * @return {{start: string, end: string}} Y-m-d
     */
    static last30Days() {
        const start = new persianDate()
            .subtract("days", 30)
            .toCalendar("gregorian");
        const end = new persianDate().toCalendar("gregorian");

        const start_day = String(start.date()).padStart(2, "0");
        const start_month = String(start.month()).padStart(2, "0");
        const start_year = start.year();

        const end_day = String(end.date()).padStart(2, "0");
        const end_month = String(end.month()).padStart(2, "0");
        const end_year = end.year();

        return {
            start: `${start_year}-${start_month}-${start_day}`,
            end: `${end_year}-${end_month}-${end_day}`,
        };
    }

    /**
     * get tommorow date
     * @return {Date}
     */
    static tommorow() {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        return tomorrow;
    }

    /**
     *
     * @param {string} start
     * @param {string} end
     * @return {Promise<Array>}
     */
    static daysArray(start, end) {
        const persian_start = new persianDate(new Date(start));
        const persian_end = new persianDate(new Date(end));
        const days = [];

        let day_to_add = 0;
        const diff = persian_end.diff(persian_start, "days");

        do {
            days.push(persian_start.add("d", day_to_add));
            if (day_to_add >= diff) {
                return Promise.resolve(days);
            }
        } while (++day_to_add);
    }

    /**
     *
     * @param {string} start
     * @param {string} end
     * @return {Promise<Array>}
     */
    static monthesArray(start, end) {
        const persian_start = new persianDate(new Date(start));
        const persian_end = new persianDate(new Date(end));
        const monthes = [];

        let month_to_add = 0;
        const diff = persian_end.diff(persian_start, "month") + 1;

        do {
            monthes.push(persian_start.add("M", month_to_add));
            if (month_to_add >= diff) {
                return Promise.resolve(monthes);
            }
        } while (++month_to_add);
    }

    /**
     *
     *
     * @static
     * @param {Date} date
     * @return {boolean}
     * @memberof DateUtils
     */
    static isBeforeToday(date) {
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return date < today;
    }

    /**
     * @static
     * @param {*} persian_date
     * @return {number}
     * @memberof DateUtils
     */
    static daysFromToday(persian_date) {
        const now = new persianDate();
        return persian_date.diff(now, "days");
    }
}

export { DateUtils };
